module.exports = __webpack_public_path__ + "media/images/laptop_icon-a921bc71504ca4a092dd66fe3ccb2d39.png";